
import { AttributesMixin, define, Model } from "@type-r/models";
import { fetchJson } from "api/endpoint";
import { root } from '../../../inmatch/api/common';

export type PaymentRaType = 'unreconciled' | 'unresolved-payments' | 'unresolved-ras';
@define export class UnresolvedGroupInfo extends Model {

    static attributes = {
        groupDate: Date,
        count: Number,
        amountSum: Number
    }

    static async fetchUnresolvedPayments() {
        const url = root + "landing/unresolved-payments";
        return await fetchJson('GET', url);
    }

    static async fetchUnresolvedRas() {
        const url = root + "landing/unresolved-ras";
        return await fetchJson('GET', url);
    }
}
export interface UnresolvedGroupInfo extends AttributesMixin<typeof UnresolvedGroupInfo> { }

@define export class LandingPaymentInfo extends Model {
    static attributes = {
        relationshipId: Number,
        count: Number,
        amountSum: Number,
        customerName: String,
        customerExternalId: String
    }

    static async fetchUnreconciledPayments() {
        const url = root + "landing/unreconciled-payments";
        return await fetchJson('GET', url);
    }

    static async fetchAutoReconciledPayments(timeRangeValue) {
        const url = root + `landing/review/auto-reconciled/${timeRangeValue}`;
        return await fetchJson('GET', url);
    }
}
export interface LandingPaymentInfo extends AttributesMixin<typeof LandingPaymentInfo> { }
